$(document).ready(function () {
  $("body").on("click", ".ce-textpic > .ce-bodytext > p > a", function () {
    if (typeof gtag != "undefined") {
      gtag("event", "Click", {
        event_category: "category galery",
        event_label: window.location.href,
      });
    }
  });
  $("main form").each(function () {
    let parentObject = $(this).parent();
    if (typeof parentObject.attr("id") !== "undefined") {
      let contentId = parentObject.attr("id").replace("c", "");
      if ($(this).attr("id") == "kontakt-AllgemeineAnfrage_1-" + contentId) {
        $("body").on(
          "submit",
          "#kontakt-AllgemeineAnfrage_1-" + contentId,
          function () {
            if (typeof gtag != "undefined") {
              gtag("event", "brochure", { event_label: window.location.href });
            }
          }
        );
      }
      if ($(this).attr("id") == "anfrageProspekte-" + contentId) {
        $("body").on("submit", "#anfrageProspekte-" + contentId, function () {
          if (typeof gtag != "undefined") {
            gtag("event", "brochure", { event_label: window.location.href });
          }
        });
      }
      if ($(this).attr("id") == "kontaktHundhausen-" + contentId) {
        $("body").on("submit", "#kontaktHundhausen-" + contentId, function () {
          if (typeof gtag != "undefined") {
            gtag("event", "contact", { event_label: window.location.href });
          }
        });
      }
      if ($(this).attr("id") == "kontakt-Bauleistungen-" + contentId) {
        $("body").on(
          "submit",
          "#kontakt-Bauleistungen-" + contentId,
          function () {
            if (typeof gtag != "undefined") {
              gtag("event", "Allgmein", { event_label: window.location.href });
            }
          }
        );
      }
    }
  });
});
